<template>
    <div class="max-w-3xl px-2 mx-auto">
        <WebCamUI v-if="!exibirLoader" 
            :fullscreenState="fullscreenState" 
            :takePhotoButton="false"
            :fullscreenButton="false"
            :imageType="'image/png'"
            @fullscreen-exited="sairFullScreen"
            @photoTaken="tirarFoto"
            @error="tratarErro"
        />
        <Loader class="flex flex-col justify-center items-center gap-1 p-4" v-else/>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import ComponenteFotoService from '@/services/componentes/ComponenteFotoService';
import WebCamUI from '@/common/foto/components/WebCamUI.vue';
import Loader from '@/components/Loader.vue';
import GeolocalizacaoFotoConstant from '@/constants/GeolocalizacaoFotoConstant';
import FuncoesHelper from '@/helpers/FuncoesHelper';

export default defineComponent({
    name: 'TirarFoto',
    components: {
        WebCamUI,
        Loader
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        async tirarFoto(dados) {
            if (dados) {
                this.$store.state.fotosTemp = {
                    blob: dados.blob,
                    imgUrl: dados.image_data_url,
                    largura: dados.width, 
                    altura: dados.height,
                    geolocalizacao: GeolocalizacaoFotoConstant.LOCALIZACAO,
                    horario: Date.now()
                };

                this.temFoto = true;

                await new Promise(resolve => setTimeout(resolve, 500));
                
                this.$router.push({
                    name: 'DetalheFoto',
                    params: { 
                        identificadorRota: this.identificador, 
                        idComponente: this.idComponente, 
                        localRealizacao: this.localRealizacao,
                        modulo: this.modulo,
                        etapa: this.etapaAtual,
                    },
                    query: { tipo: this.tipo, id: this.idImagem }
                });
            }          
        },
        sairFullScreen() {
            if (!this.temFoto) {                
                this.exibirLoader = true;
                this.$router.push(`/${this.identificador}/${this.localRealizacao}/${this.modulo}/etapa/${this.etapaAtual}`);
            }
        },
        tratarErro(dados) {
            console.error(dados);
        },
        
    },
    setup(props) {
        try {
            return ComponenteFotoService.tirarFotoSetup(props);
        } catch (error) {
            FuncoesHelper.pushRouter('Etapas', {
                identificador: props.identificador,
                localRealizacao: props.localRealizacao,
                modulo: props.modulo,
                etapa: props.etapa
            })
        }
    }
})
</script>